<script>
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    count: {
      type: String,
      default: '',
    },
    isChildMenuActive: {
      type: Boolean,
      default: false,
    },
    openInNewPage: {
      type: Boolean,
      default: false,
    },
    // Icon-only pill (no visible label at any breakpoint) — used for
    // secondary actions like DOCS that live in the topnav's actions
    // cluster, as opposed to the main nav links which always show a label
    // on sm+ screens.
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip.bottom="iconOnly ? $t(`SIDEBAR.${name}`) : ''"
      :href="href"
      class="topnav-item flex items-center justify-center flex-shrink-0 relative transition-colors duration-150"
      :class="[
        { 'topnav-item--active': isActive || isChildMenuActive },
        iconOnly
          ? 'w-9 h-9 rounded-lg'
          : 'h-9 px-3 gap-2 rounded-full text-[13px] font-semibold',
      ]"
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <fluent-icon :icon="icon" size="16" />
      <span v-if="iconOnly" class="sr-only">{{ $t(`SIDEBAR.${name}`) }}</span>
      <span v-else class="hidden sm:inline whitespace-nowrap">
        {{ $t(`SIDEBAR.${name}`) }}
      </span>
      <span v-if="count" class="topnav-item__badge absolute -top-1 -right-1">
        {{ count }}
      </span>
    </a>
  </router-link>
</template>
